module.exports = __webpack_public_path__ + "assets/img/dh3.9cf4b314.jpg";